import { render, staticRenderFns } from "./TipoDocumentoField.vue?vue&type=template&id=b578d420&scoped=true&"
import script from "./TipoDocumentoField.vue?vue&type=script&lang=js&"
export * from "./TipoDocumentoField.vue?vue&type=script&lang=js&"
import style0 from "./TipoDocumentoField.vue?vue&type=style&index=0&id=b578d420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b578d420",
  null
  
)

export default component.exports